export default __webpack_public_path__ + "static/media/a006-a.d8fd690f.png";